const domainsWithoutTcfConsent = ['autohebdo.net', 'autotrader.ca'];

function calculateEtldPlusOne(hostname) {
    const numberOfDomainParts = hostname.endsWith('.com.tr') || hostname.endsWith('.com.ua') ? 3 : 2;
    return hostname
        .split('.')
        .slice(-1 * numberOfDomainParts)
        .join('.')
        .replace(/:.*$/, '');
}
function loadGtmScript(containerId) {
    if (!containerId) {
        console.error('Google Tag Manager container ID is required');
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
}

module.exports = {
    loadGtmScript: loadGtmScript,
    calculateEtldPlusOne: calculateEtldPlusOne,
    domainsWithoutTcfConsent: domainsWithoutTcfConsent,
};



// WEBPACK FOOTER //
// ./src/gtm/utils.js